<template>
  <div>
    <vxe-grid
      ref="skuTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :height="400"
      size="mini"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './sku-table-columns'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.skuTable.getTableData()
      return fullData || []
    },
    del(row) {
      this.$refs.skuTable.remove(row)
    },
  },
}
</script>
